export const getEmploymentTypesFrag = `
    name
    groupName
`;
